<template>
    <b-modal
        v-model="isComponentModalActive"
        has-modal-card
        trap-focus
        :destroy-on-hide="true"
        aria-role="dialog"
        aria-label="Example Modal"
        aria-modal
    >
        <template #default="props">
            <div class="modal-card" style="min-width: 860px">
                <header class="modal-card-head">
                    <p class="modal-card-title">Редактировать пользователя</p>
                    <button
                        type="button"
                        class="delete"
                        @click="props.close"/>
                </header>
                <section class="modal-card-body">
                    <user :user-id="userId" @processing="disabled = $event" ref="user" />
                </section>
                <footer class="modal-card-foot">
                    <b-button
                        label="Сохранить"
                        type="is-success"
                        @click="save()"
                        :disabled="disabled"
                    />
                    <b-button
                        label="Закрыть"
                        @click="props.close" />
                </footer>
            </div>
        </template>
    </b-modal>
</template>
<script>


import User from './User'
export default {
    props: {
        userId: {
            default: null,
            required: true,
        },
    },
    components: {
        User,
    },
    data() {
        return {
            disabled: false
        }
    },
    computed: {
        isComponentModalActive: {
            get() {
                return this.userId !== null
            },
            set(val) {
                if(!val) this.$emit('update:userId', null)
            }
        },
    },
    methods: {
        save() {
            this.$refs.user.save().then(()=>{
                this.isComponentModalActive = false
                this.$buefy.toast.open({
                    duration: 4000,
                    message: `Пользователь сохранен`,
                    type: 'is-success',
                    hasIcon: true,
                    position: 'is-bottom'
                })
                this.$emit('saved')
            })
        }
    }
}
</script>